// @flow
import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import { User } from '../../types'
import { rebateAmount } from '../../utils'
import { fetchProperty } from '../../actions/properties'
import { createOffer } from '../../actions/forms'
import PageHeader from '../../components/PageHeader'
import RebateButton from '../../components/RebateButton'
import PropertyCard from '../../components/PropertyCard'
import GoogleMap from '../../components/GoogleMap'
import OfferForm from './components/OfferForm'

type Props = {
  user: User,
  property: Object,
  createOffer: Function,
  fetchProperty: Function,
  params: { mlsId: number }
}

class NewOffer extends Component {
  componentDidMount() {
    this.props.fetchProperty(this.props.params.mlsId)
  }

  props: Props

  handleSubmit = (data) => this.props.createOffer(this.props.user.id, data)

  render() {
    const { property } = this.props
    const rebate = rebateAmount(property.listPrice)
    const address =
      property.address &&
      `${property.address.full}, ${property.address.city}, ${property.address.state} ${property.address.postalCode}`

    return (
      <div>
        <Helmet title="Buy a Home Online" />
        <PageHeader text="Make an Offer">
          {rebate > 0 && (
            <div style={{ marginBottom: '1rem' }}>
              Get a <RebateButton rebate={rebate} /> rebate when you purchase
              with Kief Realty.
            </div>
          )}
          Please fill out the form below and we will be in contact with you to
          discuss your offer.
        </PageHeader>
        <div style={{ padding: '2rem 0' }}>
          <div className="container">
            <p style={{ textAlign: 'right' }}>
              Questions? Call (217) 379-2222 or email us at info@kiefrealty.com
            </p>
            <div className="row" style={{ marginBottom: '3rem' }}>
              <div className="col-md-6 col-xs-12">
                <PropertyCard property={property} />
              </div>
              <div className="col-md-6 col-xs-12">
                <GoogleMap
                  address={address}
                  lat={property.geo && property.geo.lat}
                  lng={property.geo && property.geo.lng}
                />
              </div>
            </div>
            <OfferForm
              property={property}
              onSubmit={this.handleSubmit}
              initialValues={{ payment: 'cash', other_agent: 'false' }}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    user: state.session.currentUser,
    property: state.properties.current
  }),
  {
    createOffer,
    fetchProperty
  }
)(NewOffer)



// WEBPACK FOOTER //
// ./src/views/NewOffer/index.js